import React from 'react';
import { FaCut, FaPalette, FaSpa } from 'react-icons/fa';
import img1 from '../assets/celebrity cuts (14).png';
import img2 from '../assets/celebrity cuts (15).png';
import img3 from '../assets/celebrity cuts (16).png';
import './ImageGallery.css';

const ImageGallery = () => {
  const galleryItems = [
    {
      id: 1,
      image: img1,
      title: 'Precision Cuts',
      description: 'Expertly crafted haircuts tailored to your unique style and facial features',
      icon: <FaCut className="gallery-icon" />
    },
    {
      id: 2,
      image: img2,
      title: 'Vibrant Coloring',
      description: 'Custom color services using premium products for lasting brilliance',
      icon: <FaPalette className="gallery-icon" />
    },
    {
      id: 3,
      image: img3,
      title: 'Luxury Treatments',
      description: 'Revitalizing treatments for healthy, beautiful hair',
      icon: <FaSpa className="gallery-icon" />
    }
  ];

  return (
    <section className="image-gallery">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Signature Services</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">Experience the pinnacle of hairdressing excellence</p>
        </div>
        
        <div className="gallery-grid">
          {galleryItems.map((item) => (
            <div key={item.id} className="gallery-item">
              <div className="gallery-item-inner">
                <div className="image-container">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="gallery-image"
                    loading="lazy"
                  />
                  <div className="image-overlay">
                    <div className="icon-wrapper">
                      {item.icon}
                    </div>
                  </div>
                </div>
                <div className="gallery-text">
                  <h3 className="gallery-title">{item.title}</h3>
                  <p className="gallery-description">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="cta-container">
          <button className="cta-button">Book Your Consultation</button>
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;
